<template>

  <div>

    <span class="hitklick hitklick-Hitklick_Logo" v-if="id===1"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span></span>

    <span class="hitklick hitklick-Hitklick_Logo_SW" v-if="id===2"></span>
  </div>

</template>

<script>
export default{
  props: {id: Number}
}
</script>
